import React from 'react';
import ReactDOM from 'react-dom';
import "antd/dist/reset.css";
import './index.scss';
import App from './App';
import { ConfigProvider } from 'antd';
import pt_BR from 'antd/locale/pt_BR';

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={pt_BR} theme={{ hashed: false }}>
      <App />
    </ConfigProvider >
  </React.StrictMode>,
  document.getElementById('root')
);